import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

// Public endpoints
export const getRecruitmentsByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(API_ENDPOINTS.RECRUITMENTS.GET_BY_LANGUAGE(languageCode));
    return response.data;
};

export const getRecruitmentDepartmentsByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(API_ENDPOINTS.RECRUITMENT_DEPARTMENTS.GET_BY_LANGUAGE(languageCode));
    return response.data;
};

export const getRecruitmentJobTypesByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(API_ENDPOINTS.RECRUITMENT_JOB_TYPES.GET_BY_LANGUAGE(languageCode));
    return response.data;
};
